/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

// TODO: We need this imported somehow. Right now it fails on build
import "@greeter/theme";

import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";

/* Theme variables */
import "./App.scss";

// For v6
import { setupIonicReact, getPlatforms } from "@ionic/react";
const platforms = new Set(getPlatforms());
setupIonicReact({
  swipeBackEnabled: false,
  mode: !platforms.has("desktop") ? "ios" : undefined,
});
